export default __webpack_public_path__ + "img/4932c85573f21437aa56074b9f5371bb.svg";